<template>
  <div class="container-view page-view">
    <!-------------------------------------------------------页面顶部title--------------------------------------------------------->
    <section class="page_title">
      <h2>粤冷链监控</h2>
    </section>
    <section class="page_main">
      <!-------------------------------------------------------页面左侧部分--------------------------------------------------------->
      <section class="page_left">
        <h2 class="section_title">进口冷冻食品专用车</h2>
        <!--左上-->
        <div class="echarts_container height30" v-loading="vehicleDataLoading">
          <div class="width60 vehicleInfo">
            <div v-for="(v, i) in vehicleDataDom" :key="i">
              <div :class="['icon_info', `vehicle_icon_bg_${i}`]">
                <i :class="['icon', `vehicle_icon_${i}`]"></i>
              </div>
              <div class="vehicle_info">
                <p class="cGray">{{ v.label }}</p>
                <p>
                  <span class="number">{{ v.value }}</span>
                  <span class="unit">{{ v.unit }}</span>
                </p>
              </div>
            </div>
          </div>
          <!--近7日平均使用率-->
          <div class="width40 useRate">
            <p class="sub_title">近7日平均使用率</p>
            <div
              class="sub_echarts"
              ref="echartsUseRate"
              style="font-size:1rem"
            ></div>
          </div>
        </div>
        <!--左中-->
        <div class="echarts_container height40" v-loading="vehicleDataLoading">
          <!--近7日车辆数据-->
          <div class="width60 vehicleInfo vehicleByWeek">
            <div
              v-for="(v, i) in vehicleDataByWeekDom"
              :key="i"
              class="height25"
            >
              <div
                :class="[
                  { triangle: i > 1 },
                  (runTimeUpDrop && i == 3) || (runOdometerUpDrop && i == 2)
                    ? 'greenTriangle'
                    : ''
                ]"
              ></div>
              <div class="vehicle_info">
                <p class="cGray">{{ v.label }}</p>
                <p>
                  <span class="number">{{ v.value }}</span>
                  <span class="unit">{{ v.unit }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="width40 vehicleInfo">
            <div
              class="echarts_bar height25"
              v-for="(v, i) in vehicleDataByWeekDom"
              :key="i"
              :id="`echartsVehicleBar${i}`"
              style="font-size:1rem"
            ></div>
          </div>
        </div>
        <!--左下-->
        <div
          class="echarts_container height30 vehicleTrend"
          v-loading="vehicleTrendLoading"
        >
          <div class="echarts_title">近30天运营走势</div>
          <div ref="vehicleTrend" class="echarts" style="font-size:1rem"></div>
        </div>
      </section>
      <!-------------------------------------------------------页面中间部分------------------------------------------------------->
      <section class="page_center">
        <div class="page_center-top" v-loading="totalLoading">
          <template v-for="(v, i) in totalDomData">
            <div
              :key="i"
              :class="['center_total', `center_total_${i} `, { mr0: i == 3 }]"
            >
              <div>
                <p class="number">{{ v.value }}</p>
                <p>{{ v.name }}</p>
              </div>
              <div :class="`icon total_icon_${i}`"></div>
            </div>
          </template>
        </div>
        <div class="page_center-img">
          <div class="title">进口冷冻食品监管全流程示意图</div>
          <div class="content">
            <img src="@/assets/images/storageAnalysis/flowChart.png" alt="" />
          </div>
        </div>
      </section>
      <!-------------------------------------------------------页面右侧部分------------------------------------------------------->
      <section class="page_right">
        <h2 class="section_title posRight">入库预约分析</h2>
        <!--右上 冷库数据分析-->
        <div class="height40 inStorage" v-loading="storageLoading">
          <!--今日预约单量-->
          <div class="bookingInfo">
            <div>
              <p>
                <span class="number cBlue">{{
                  orderNumber.bookingNumber
                }}</span>
                <span class="unit">单</span>
              </p>
              <p class="cGray">今日入库预约单量</p>
            </div>
            <div>
              <p>
                <span class="number cBlue">{{
                  orderNumber.totalBookingNumber
                }}</span>
                <span class="unit">吨</span>
              </p>
              <p class="cGray">今日入库预约总量</p>
            </div>
          </div>
          <!--完成与未完成单量-->
          <div class="echart_complete">
            <div ref="echartsComplete" class="echartsComplete"></div>
            <div ref="echartsComplete2" class="echartsComplete2"></div>
            <span class="echartsLabel">{{ complete }}单</span>
            <span class="splitLine"></span>
            <div class="echarts_title">
              <p class="cGray">已完成完成单量</p>
              <p class="cGray">未完成单量</p>
            </div>
          </div>
          <!--预约单状态-->
          <div class="orderStatus">
            <div v-for="(v, i) in orderStatusDomData" :key="i">
              <div
                class="echarts"
                :id="`echartOrderStatus${i}`"
                style="font-size:1rem"
              ></div>
              <div class="number">{{ v.number }}</div>
              <div class="cGray">{{ v.label }}</div>
            </div>
          </div>
        </div>
        <!--右中 冷库变化趋势-->
        <div class="height30 bookingRate" v-loading="storageLoading">
          <div class="echarts_title">近7日入库预约检查比例及预约消毒比例</div>
          <div class="echartsArea">
            <div
              ref="inStorageBookingCheck"
              class="echarts"
              style="font-size:1rem"
            ></div>
            <div
              ref="inStorageBookingRate"
              class="echarts"
              style="font-size:1rem"
            ></div>
          </div>
        </div>
        <!--右下 近30天进出 总趋势-->
        <div
          class="echarts_container height30 inStorageBooking"
          v-loading="storageLoading"
        >
          <div class="echarts_title">近30日入库预约分析</div>
          <div
            ref="inStorageBooking"
            class="echarts"
            style="font-size:1rem"
          ></div>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import Echarts from "echarts";
import _ from "lodash";
import { mapGetters, mapMutations } from "vuex";
import {
  fetchVehicleData,
  fetchVehicleTrendData,
  fetchInstorageData,
  fetchTotalData
} from "@/api/board/storageAnalysis.js";
import legendOnlineIcon from "@/assets/images/gdHome/legend_1.png";
import legendTempIcon from "@/assets/images/gdHome/legend_2.png";
export default {
  data() {
    return {
      clientWidth: document.documentElement.clientWidth, // 页面宽度
      clientHeight: document.documentElement.clientHeight, // 页面高度
      // -----------------------左侧 车辆数统计------------------------------
      vehicleDataLoading: false,
      vehicleDataDom: [
        {
          label: "总车辆数",
          value: "",
          unit: "辆"
        },
        {
          label: "今日运行车辆数",
          value: "",
          unit: "辆"
        },
        {
          label: "今日车辆使用率",
          value: "",
          unit: "%"
        }
      ],
      // 平均使用率
      echartsUseRateObj: null,
      runTimeUpDrop: 0,
      runOdometerUpDrop: 0,
      // ----------------------- 近7日数据 ----------------------
      vehicleDataByWeekDom: [
        {
          label: "近7日行驶里程",
          value: "",
          unit: "KM"
        },
        {
          label: "近7日行驶时长",
          value: "",
          unit: "H"
        },
        {
          label: "日均里程",
          value: "",
          unit: "公里/车"
        },
        {
          label: "日均行驶时长",
          value: "",
          unit: "小时/车"
        }
      ],
      echartsVehicleBar0: null,
      echartsVehicleBar1: null,
      echartsVehicleBar2: null,
      echartsVehicleBar3: null,
      //  ----------------------- 运营走势 -----------------------
      vehicleTrendData: [],
      vehicleTrendLoading: false,
      vehicleTrendObj: null,
      //  ----------------------- 预约单量与总量 -----------------------
      storageLoading: false,
      orderNumber: {
        bookingNumber: "",
        totalBookingNumber: ""
      },
      //  ----------------------- 完成与未完成量 -----------------------
      storageCompleteObj: null,
      echartsComplete2Obj: null,
      complete: "",
      //  ----------------------- 预约单状态 -----------------------
      orderStatusDomData: [
        {
          label: "待报到",
          number: ""
        },
        {
          label: "待检测",
          number: ""
        },
        {
          label: "待消毒",
          number: ""
        },
        {
          label: "已完成",
          number: ""
        }
      ],
      echartOrderStatus0: null,
      echartOrderStatus1: null,
      echartOrderStatus2: null,
      echartOrderStatus3: null,
      //  ----------------------- 近7日入库预约检查比例及预约比例 -----------------------
      inStorageBookingCheckObj: null,
      inStorageBookingRateObj: null,
      //  ----------------------- 近30天入库预约 -----------------------
      inStorageBookingObj: null,
      inStorageBookingLoading: false,
      inStorageBookingData: false,
      //  ----------------------- 中间汇总部分 -----------------------
      totalLoading: false,
      totalDomData: [
        {
          name: "企业总数",
          value: 0
        },
        {
          name: "仓库总数",
          value: 0
        },
        {
          name: "预约单总量",
          value: 0
        },
        {
          name: "仓库吞吐总量",
          value: 0
        }
      ]
      //  ----------------------- 中间地图 -----------------------
    };
  },
  computed: {
    ...mapGetters(["isFullScreen"])
  },
  created() {
    !this.isFullScreen && this.updateFullScreen();
  },

  mounted() {
    this.setFontSize();
    this.getVehicleData(); // 车辆数据
    this.getVehicleTrendLeftData(); // 运营走势
    this.getInstorageData(); // 入库数据
    this.getTotalData(); // 中间的汇总数据
    window.onresize = () => {
      this.setFontSize();
      this.resetEcharts();
    };
  },
  methods: {
    ...mapMutations(["updateFullScreen"]),
    setFontSize() {
      // 设置html的font-sezi
      let html = document.documentElement;
      let windowWidth = html.clientWidth;
      html.style.fontSize = windowWidth / 14.4 + "px";
    },
    // 重置echarts
    resetEcharts() {
      this.echartsUseRateObj && this.echartsUseRateObj.resize();
      this.echartsVehicleBar0 && this.echartsVehicleBar0.resize();
      this.echartsVehicleBar1 && this.echartsVehicleBar1.resize();
      this.echartsVehicleBar2 && this.echartsVehicleBar2.resize();
      this.echartsVehicleBar3 && this.echartsVehicleBar3.resize();
      this.vehicleTrendObj && this.vehicleTrendObj.resize();
      this.storageCompleteObj && this.storageCompleteObj.resize();
      this.echartsComplete2Obj && this.echartsComplete2Obj.resize();
      this.inStorageBookingObj && this.inStorageBookingObj.resize();
      this.echartOrderStatus0 && this.echartOrderStatus0.resize();
      this.echartOrderStatus1 && this.echartOrderStatus1.resize();
      this.echartOrderStatus2 && this.echartOrderStatus2.resize();
      this.echartOrderStatus3 && this.echartOrderStatus3.resize();
      this.inStorageBookingCheckObj && this.inStorageBookingCheckObj.resize();
      this.inStorageBookingRateObj && this.inStorageBookingRateObj.resize();
    },
    // 渐变色
    setLinearColor(startColor, endColor) {
      return new Echarts.graphic.LinearGradient(
        0,
        0,
        0,
        1,
        [
          {
            offset: 0,
            color: startColor
          },
          {
            offset: 1,
            color: endColor
          }
        ],
        false
      );
    },
    // 渐变色
    setRightLinearColor(startColor, endColor) {
      return new Echarts.graphic.LinearGradient(
        0,
        1,
        0,
        0,
        [
          {
            offset: 0,
            color: startColor
          },
          {
            offset: 1,
            color: endColor
          }
        ],
        false
      );
    },
    /******************************车辆数据分析*********************************/
    // 请求数据
    async getVehicleData() {
      try {
        this.vehicleDataLoading = true;
        let { code, result, message } = await fetchVehicleData();
        if (code) {
          if (result) {
            this.vehicleDataDom[0].value = result.allVehicleCount;
            this.vehicleDataDom[1].value = result.importVehicleCount;
            this.vehicleDataDom[2].value = result.importVehicleUseRate;
            // 近7日平均使用率
            this.initUseRateEcharts(result.weakVehicleUseRate.toFixed(1));
            // 行驶里程与运行时长
            let data = result.dayImportVehicleData;
            let totalData = {
              totalRunOdometer: 0,
              totalRunTime: 0,
              totalRunOdometerAvg: 0,
              totalRunTimeAvg: 0
            };
            data.forEach(v => {
              totalData.totalRunOdometer += Number(v.runOdometerSum);
              totalData.totalRunTime += Number(v.runTimeSum);
              totalData.totalRunOdometerAvg += Number(v.runOdometerAvg);
              totalData.totalRunTimeAvg += Number(v.runTimeAvg);
            });
            this.vehicleDataByWeekDom[0].value = Number(
              totalData.totalRunOdometer
            ).toFixed(1);
            this.vehicleDataByWeekDom[1].value = Number(
              totalData.totalRunTime
            ).toFixed(1);
            this.vehicleDataByWeekDom[2].value = Number(
              totalData.totalRunOdometerAvg / 7
            ).toFixed(1);
            this.vehicleDataByWeekDom[3].value = Number(
              totalData.totalRunTimeAvg / 7
            ).toFixed(1);
            // 箭头
            this.runTimeUpDrop = result.runTimeUpDrop;
            this.runOdometerUpDrop = result.runOdometerUpDrop;
            // 近7日行驶里程
            this.echartsVehicleBar0 = Echarts.init(
              document.getElementById("echartsVehicleBar0")
            );
            this.echartsVehicleBar0.setOption(
              this.echartsBarOption(data, ["statTime", "runOdometerSum"], 0)
            );
            // 近7日行驶时长
            this.echartsVehicleBar1 = Echarts.init(
              document.getElementById("echartsVehicleBar1")
            );
            this.echartsVehicleBar1.setOption(
              this.echartsBarOption(data, ["statTime", "runTimeSum"], 1)
            );
            // 日均里程
            this.echartsVehicleBar2 = Echarts.init(
              document.getElementById("echartsVehicleBar2")
            );
            this.echartsVehicleBar2.setOption(
              this.echartsBarOption(data, ["statTime", "runOdometerAvg"], 0)
            );
            // 日均时长
            this.echartsVehicleBar3 = Echarts.init(
              document.getElementById("echartsVehicleBar3")
            );
            this.echartsVehicleBar3.setOption(
              this.echartsBarOption(data, ["statTime", "runTimeAvg"], 2)
            );
          }
        } else {
          this.errorMessage(message || "获取车辆数据失败");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.vehicleDataLoading = false;
      }
    },
    // 平均使用率
    initUseRateEcharts(data) {
      let curData = Number(data);
      let option = {
        grid: {
          left: 80,
          top: "5%", // 设置条形图的边距
          right: "2%",
          bottom: "5%"
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            interval: true,
            formatter: params => {
              let str = `{a|${params}}{b|%}`;
              if (
                (params < curData && params + 10 >= curData) ||
                (params < curData && params + 20 >= curData)
              ) {
                str = `{c|${curData}}{d|%}`;
              }
              return str;
            },
            rich: {
              a: {
                color: "#333",
                fontSize: 14
              },
              b: {
                color: "#333",
                fontSize: 12
              },
              c: {
                color: "#333",
                fontSize: 18,
                fontWeight: 600
              },
              d: {
                color: "#333",
                fontSize: 14,
                fontWeight: 600
              }
            },
            fontSize: 12
          },
          axisTick: {
            show: false
          }
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true
          }
        },
        series: [
          {
            // 分隔
            type: "pictorialBar",
            itemStyle: {
              normal: {
                color: "#E5F4FB"
              },
              emphasis: {
                color: "#E5F4FB"
              }
            },
            symbolRepeat: "fixed",
            symbolMargin: 3,
            symbol: "rect",
            symbolClip: true,
            symbolSize: ["100%", "10%"],
            symbolPosition: "start",
            symbolOffset: [0, 0],
            symbolBoundingData: 100,
            hoverAnimation: false,
            data: [100],
            z: 1
          },
          {
            // 进度
            type: "pictorialBar",
            itemStyle: {
              normal: {
                color: new Echarts.graphic.LinearGradient(
                  0,
                  0,
                  1,
                  0,
                  [
                    {
                      offset: 0,
                      color: "#00CCCE"
                    },
                    {
                      offset: 1,
                      color: "#0091DA"
                    }
                  ],
                  false
                )
              }
            },
            symbolRepeat: "fixed",
            symbolMargin: 3,
            symbol: "rect",
            symbolClip: true,
            symbolSize: ["100%", "10%"],
            symbolPosition: "start",
            symbolOffset: [0, 0],
            symbolBoundingData: 100,
            hoverAnimation: false,
            data: [curData],
            z: 2
          }
        ]
      };
      this.echartsUseRateObj = Echarts.init(this.$refs.echartsUseRate);
      this.echartsUseRateObj.setOption(option);
    },
    // 车辆柱状图
    echartsBarOption(data, dimensions, type) {
      let colors = [
        {
          start: "#0673EC",
          end: "#3D44F4"
        },
        { start: "#03CCCF", end: "#0092D9" },
        { start: "#63DBD6", end: "#2AC4C1" }
      ];
      let option = {
        grid: {
          top: 20,
          bottom: 0,
          left: 10,
          right: 10
        },
        xAxis: {
          type: "category",
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
          // data: dataX
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        dataset: {
          dimensions: dimensions,
          source: data
        },
        series: [
          {
            // data: dataY,
            type: "bar",
            barWidth: "35%",
            color: this.setLinearColor(colors[type].start, colors[type].end),
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0]
            }
          }
        ]
      };
      return option;
    },
    /******************************近30天运营走势*********************************/
    // 请求数据
    async getVehicleTrendLeftData() {
      try {
        this.vehicleTrendData = [];
        this.vehicleTrendLoading = true;
        let { code, result, message } = await fetchVehicleTrendData();
        this.vehicleTrendData = _.cloneDeep(result);
        if (!code) {
          this.errorMessage(message || "获取运营走势数据失败");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.vehicleTrendObj = Echarts.init(this.$refs.vehicleTrend);
        this.vehicleTrendObj.setOption(
          this.initVehicleTrendEcharts(
            this.vehicleTrendData,
            1,
            ["statTime", "runOdometerSum", "runTimeSum"],
            ["运行公里", "运行时长"]
          )
        );

        this.vehicleTrendLoading = false;
      }
    },
    initVehicleTrendEcharts(data = [], type, dimensions, legendArr) {
      let colors = [
        {
          start: "rgba(94,170,255,1)",
          end: "rgba(45,81,216,1)"
        },
        { start: "rgba(159,254,255,1)", end: "rgba(15,156,226,1)" }
      ];
      let yAxisStr = "{value}k";
      if (type === 2) {
        yAxisStr = "{value}";
      }
      let option = {
        color: [
          this.setLinearColor(colors[0].start, colors[0].end),
          this.setLinearColor(colors[1].start, colors[1].end)
        ],
        legend: {
          show: true,
          data: [
            {
              name: legendArr[0],
              icon: `image://${legendOnlineIcon}`
            },
            {
              name: legendArr[1],
              icon: `image://${legendTempIcon}`
            }
          ],
          top: "5%",
          right: "-2%",
          textStyle: {
            color: "#999"
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: "25%",
          bottom: 0,
          left: 10,
          right: 10,
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              show: true,
              color: "#999"
            },
            axisLine: {
              show: true,
              lineStyle: { color: "#999" }
            },
            axisTick: {
              inside: true,
              length: 3,
              lineStyle: {
                width: 2
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            splitNumber: 5,
            splitLine: {
              show: true
            },
            axisLabel: {
              show: true,
              formatter: yAxisStr,
              color: "#999"
            },
            axisLine: {
              show: false,
              lineStyle: { color: "#999" }
            },
            axisTick: {
              show: false
            }
          },
          {
            type: "value",
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              formatter: "{value}",
              color: "#999"
            },
            axisLine: {
              show: false,
              lineStyle: { color: "#999" }
            },
            axisTick: {
              show: false
            }
          }
        ],
        dataset: {
          dimensions: dimensions,
          source: data
        },
        series: [
          {
            name: legendArr[0],
            type: "line",
            smooth: true,
            areaStyle: {
              opacity: 0.3
            }
          },
          {
            name: legendArr[1],
            type: "line",
            smooth: true,
            yAxisIndex: 1,
            areaStyle: {
              opacity: 0.3
            },
            z: 1000
          }
        ]
      };
      return option;
    },
    //******************************入库预约分析数据*********************************/
    // 请求数据
    async getInstorageData() {
      try {
        this.storageLoading = true;
        let { code, result, message } = await fetchInstorageData();
        if (code) {
          if (result) {
            // 预约单量与总量
            this.orderNumber.bookingNumber = this.handleData(result.bookingNum);
            this.orderNumber.totalBookingNumber = this.handleData(
              result.warehouseThroughput
            );
            // 完成单量与未完成单量
            this.complete = result.complete;
            let per =
              result.complete + result.incomplete == 0
                ? 0
                : Math.round(
                    (result.complete / (result.complete + result.incomplete)) *
                      10
                  );

            let totalData = [
              ["2015/11/1", 10, "DQ"],
              ["2015/11/2", 10, "DQ"],
              ["2015/11/3", 10, "DQ"],
              ["2015/11/4", 10, "DQ"],
              ["2015/11/5", 10, "DQ"],
              ["2015/11/6", 5, "DQ"],
              ["2015/11/7", 10, "DQ"],
              ["2015/11/8", 10, "DQ"],
              ["2015/11/9", 10, "DQ"],
              ["2015/11/10", 10, "DQ"],
              ["2015/11/11", 10, "DQ"]
            ];
            let data = [];
            totalData.forEach((v, i) => {
              if (i < Number(per) + 1) {
                data.push(v);
              } else {
                data.push([v[0], "", v[2]]);
              }
            });
            this.storageCompleteObj = Echarts.init(this.$refs.echartsComplete);
            this.storageCompleteObj.setOption(this.echartsOrder(0, totalData));

            this.echartsComplete2Obj = Echarts.init(
              this.$refs.echartsComplete2
            );
            this.echartsComplete2Obj.setOption(this.echartsOrder(1, data));
            // 预约单状态
            let arr = [
              result.toBeReported,
              result.toBeTested,
              result.toBeDisinfected,
              result.complete
            ];
            arr.forEach((v, i) => {
              this.orderStatusDomData[i].number = v;
              this[`echartOrderStatus${i}`] = Echarts.init(
                document.getElementById(`echartOrderStatus${i}`)
              );
              let data = result.bookingNum ? v / result.bookingNum : 0;
              this[`echartOrderStatus${i}`].setOption(
                this.echartsOrderStatus(i, data)
              );
            });
            // 近7日入库预约检查比例
            this.inStorageBookingCheckObj = Echarts.init(
              this.$refs.inStorageBookingCheck
            );
            this.inStorageBookingCheckObj.setOption(
              this.echartsInStorageBooking(0, result.detectionRate)
            );
            //预约比例
            this.inStorageBookingRateObj = Echarts.init(
              this.$refs.inStorageBookingRate
            );
            this.inStorageBookingRateObj.setOption(
              this.echartsInStorageBooking(1, result.disRate)
            );
            // 近30天入库预约
            this.inStorageBookingObj = Echarts.init(
              this.$refs.inStorageBooking
            );

            this.inStorageBookingObj.setOption(
              this.initVehicleTrendEcharts(
                result.coldTransportResults,
                2,
                ["key", "orderNum", "grossWeight"],
                ["预约单量", "预约总量"]
              )
            );
          }
        } else {
          this.errorMessage(message || "获取入库预约分析数据失败");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.storageLoading = false;
      }
    },
    echartsOrder(type, data) {
      let option = {
        color: type == 1 ? ["#2F4DF2"] : ["#FC6D36"],
        singleAxis: [
          {
            show: false,
            top: 10,
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            type: "time",
            axisPointer: {
              label: {
                show: false
              }
            },
            splitLine: {
              show: false
            }
          }
        ],

        series: [
          {
            type: "themeRiver",
            zlevel: 10,
            data: data,
            label: {
              show: false
            }
          }
        ]
      };
      return option;
    },
    /**预约单状态**/
    echartsOrderStatus(type, data) {
      let percent = Number(data) * 100;
      percent = percent.toFixed(0); //小数位数为0
      let colors = [
        {
          start: "rgba(26,124,238,1)",
          end: "rgba(60,69,244,1)",
          bg: "#E5F0FD"
        },
        {
          start: "rgba(24,204,211,1)",
          end: "rgba(0,145,218,1)",
          bg: "#E5F4FB"
        },
        {
          start: "rgba(255,130,54,1)",
          end: "rgba(252,128,54,1)",
          bg: "#FFF0EB"
        },
        { start: "rgba(6,209,0,1)", end: "rgba(13,197,0,1)", bg: "#E9F8E5" }
      ];
      // let option = {
      //   grid: {
      //     top: "20%",
      //     bottom: "0%",
      //     left: 0,
      //     right: 0
      //   },
      //   series: [
      //     {
      //       type: "pie",
      //       hoverAnimation: false,
      //       radius: ["57%", "75%"],
      //       avoidLabelOverlap: false,
      //       labelLine: {
      //         show: false
      //       },
      //       data: [
      //         {
      //           value: data,
      //           itemStyle: {
      //             normal: {
      //               barBorderRadius: 30,
      //               color: this.setLinearColor(
      //                 colors[type].start,
      //                 colors[type].end
      //               )
      //             }
      //           },
      //           label: {
      //             show: true,
      //             position: "center",
      //             formatter: params => {
      //               let temp = `${(params.data.value * 100).toFixed(0)}`;
      //               let str = `${temp}%`;
      //               return str;
      //             },
      //             fontSize: "14%",
      //             fontWeight: 600,
      //             color: "#949597",
      //             rich: {
      //               style: {
      //                 fontSize: "12%",
      //                 fontWeight: 600,
      //                 color: "#949597",
      //                 padding: [0, 0, 0, this.calcXDirectionSizeByPercent(22)]
      //               }
      //             }
      //           }
      //         },
      //         {
      //           value: 1 - data,
      //           itemStyle: {
      //             normal: {
      //               color: colors[type].bg
      //             }
      //           }
      //         }
      //       ]
      //     }
      //   ]
      // };
      let option = {
        title: {
          text: "{a|" + percent + "}{c|%}",
          x: "center",
          y: "center",
          textStyle: {
            rich: {
              a: {
                fontSize: this.calcXDirectionSizeByPercent(18),
                color: "#333",
                fontWeight: 600
              },
              c: {
                fontSize: this.calcXDirectionSizeByPercent(14),
                color: "#333",
                fontWeight: 600
              }
            }
          }
        },

        angleAxis: {
          max: 1,
          clockwise: true, // 逆时针
          show: false // 隐藏刻度线
        },
        radiusAxis: {
          type: "category",
          show: true,
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        polar: {
          center: ["50%", "50%"],
          radius: "120%" //图形大小
        },
        series: [
          {
            type: "bar",
            data: [data],
            showBackground: true,
            backgroundStyle: {
              color: colors[type].bg
            },
            coordinateSystem: "polar",
            roundCap: true,
            barWidth: "13%",
            itemStyle: {
              normal: {
                opacity: 1,
                color: this.setLinearColor(colors[type].start, colors[type].end)
              }
            }
          }
        ]
      };
      return option;
    },
    /**近7日入库预约检查比例及预约比例**/
    echartsInStorageBooking(type, data) {
      let colors = [
        {
          start: "rgba(26,124,238,1)",
          end: "rgba(60,69,244,1)"
        },
        { start: "rgba(24,204,211,1)", end: "rgba(0,145,218,1)" }
      ];
      let option = {
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        },
        title: {
          text: type == 0 ? "预约检查比例" : "预约消毒比例",
          left: "center",
          top: "65%",
          textStyle: {
            fontSize: "14%",
            fontWeigth: 400,
            fontFamily: "微软雅黑",
            color: "#999"
          }
        },
        xAxis: {
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        series: [
          //进度图
          {
            type: "gauge",
            radius: "90%",
            center: ["50%", "65%"],
            z: 5,
            splitNumber: 1, //刻度数量
            startAngle: 180,
            endAngle: 0,
            animation: true,
            animationDuration: 10000,
            pointer: {
              show: false
            },
            //分隔线样式。
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            title: {
              show: false
            },
            axisLabel: {
              fontSize: "14%",
              color: "#D3DBFC",
              padding: [10, -40, -30, -30]
            },
            detail: {
              offsetCenter: [
                this.calcXDirectionSizeByPercent(10),
                -this.calcXDirectionSizeByPercent(20)
              ],
              formatter: params => {
                return `${params}{style|%}`;
              },
              fontSize: "24%",
              fontWeight: 600,
              color: "#333",
              rich: {
                style: {
                  fontSize: "16%",
                  fontWeight: 600,
                  color: "#333",
                  padding: [0, 0, 0, this.calcXDirectionSizeByPercent(35)]
                }
              }
            },
            data: [
              {
                value: Number(data).toFixed(1)
              }
            ],
            axisLine: {
              show: true,
              lineStyle: {
                width: 12,
                color: [
                  [
                    data / 100,
                    new Echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      {
                        offset: 0,
                        color: colors[type].start
                      },
                      {
                        offset: 1,
                        color: colors[type].end
                      }
                    ])
                  ],
                  [1, "#E5F0FD"]
                ]
              }
            }
          },
          //刻度尺
          {
            type: "gauge",
            radius: "70%",
            startAngle: 180,
            center: ["50%", "65%"],
            endAngle: 0,
            z: 2,
            axisTick: {
              show: true,
              lineStyle: {
                color: "#D3DBFC",
                width: 1
              },
              length: 4
            }, //刻度样式
            splitLine: {
              show: true,
              lineStyle: {
                color: "#D3DBFC",
                width: 1
              },
              length: 7
            }, //分隔线样式
            axisLabel: {
              color: "rgba(255,255,255,0)"
            }, //刻度节点文字颜色
            pointer: {
              show: true
            },
            axisLine: {
              show: false
            },
            label: {
              show: false
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: false
            }
          }
        ]
      };
      return option;
    },
    /******************************中间汇总数据*********************************/
    // 请求数据
    async getTotalData() {
      try {
        this.totalLoading = true;
        let { code, result, message } = await fetchTotalData();
        if (code) {
          if (result) {
            this.totalDomData[0].value = this.handleData(result.companyNum);
            this.totalDomData[1].value = this.handleData(result.warehouseNum);
            this.totalDomData[2].value = this.handleData(result.bookingNum);
            this.totalDomData[3].value = this.handleData(
              result.warehouseThroughput
            );
          }
        } else {
          this.errorMessage(message || "获取车辆数据失败");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.totalLoading = false;
      }
    },
    // 计算横向尺寸百分比
    calcXDirectionSizeByPercent(size) {
      return (size / 1920) * this.clientWidth;
    },
    // 千分符处理
    handleData(data) {
      let regex = /\d{1,3}(?=(\d{3})+$)/g;
      let str = (data + "").replace(regex, "$&,");
      return str;
    }
  }
};
</script>
<style lang="scss" scoped>
.page-view {
  position: relative;
  box-sizing: border-box;
  height: 100% !important;
  background-color: #eff0f9;

  & > section {
    float: left;
    overflow: hidden;
  }
  p {
    margin: 0;
  }
  .fl {
    float: left;
  }
  .cGray {
    color: #999;
    font-size: 0.12rem;
  }
  .number {
    color: #333;
    font-size: 0.2rem;
    font-weight: 600;
    margin-right: 0.1rem;
  }
  .unit {
    color: #333;
    font-size: 0.12rem;
    font-weight: 400;
  }
  .cBlue {
    color: #0066ff;
  }
}
/*****************顶部title***************/
.page_title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 0.6rem;
  background: url("~@/assets/images/storageAnalysis/title_bg.png") no-repeat;
  background-size: 100% 100%;
  h2 {
    font-size: 0.3rem;
    color: #fff;
  }
}
.page_main {
  width: calc(100% - 40px);
  height: calc(100% - 30px - 0.6rem);
  margin: 10px 20px 20px 20px;
  font-family: "Microsoft YaHei";
}
/*****************左侧与右侧***************/
.page_left,
.page_right {
  box-sizing: border-box;
  padding: 20px;
  float: left;
  width: 25%;
  height: 100%;
  border-radius: 8px;
  background: #fff;
  .section_title {
    position: absolute;
    margin: 0;
    top: 0.43rem;
    font-size: 0.16rem;
    font-weight: 400;
    &.posRight {
      right: 20px;
    }
  }
  .echarts_container {
    display: flex;
    justify-content: space-around;
    width: 100%;
  }
  $heights: (80, 80%), (40, 40%), (30, 30%), (25, 25%);
  @each $height, $heightPer in $heights {
    .height#{$height} {
      height: $heightPer !important;
    }
  }
  $widths: (60, 60%), (70, 70%), (50, 50%), (40, 40%), (30, 30%), (25, 25%);
  @each $width, $widthPer in $widths {
    .width#{$width} {
      width: $widthPer;
    }
  }
}
.page_left {
  .section_title {
    left: 20px;
  }
  .vehicleInfo {
    > div {
      display: flex;
      align-items: center;
      height: 33.333%;
      p {
        margin-bottom: 10px;
      }
    }
    .icon_info {
      width: 0.48rem;
      height: 0.48rem;
      border-radius: 6px;
      margin-right: 0.3rem;
    }
    $colors: (0, #3e43f4, #006fec, rgba(51, 153, 204, 0.35)),
      (1, #fc6a36, #fc8536, rgba(255, 102, 102, 0.35)),
      (2, #0090da, #00ccce, rgba(51, 204, 204, 0.35));
    @each $i, $colorStart, $colorEnd, $shadow in $colors {
      .vehicle_icon_bg_#{$i} {
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(90deg, $colorStart, $colorEnd);
        box-shadow: 0 5px 5px $shadow;
        .vehicle_icon_#{$i} {
          display: inline-block;
          width: 28px;
          height: 28px;
          background: url("~@/assets/images/storageAnalysis/vehicle_icon_#{$i}.png")
            no-repeat;
          background-size: 100% 100%;
        }
        .vehicle_icon_0 {
          width: 24px !important;
          height: 28px !important;
        }
      }
    }
  }
  .useRate {
    .sub_title {
      height: 0.35rem;
      line-height: 0.35rem;
      margin: 0;
      padding-left: 0.1rem;
      font-size: 0.12rem;
    }
    .sub_echarts {
      width: 100%;
      height: calc(100% - 0.5rem);
    }
  }
  .vehicleByWeek {
    > div {
      position: relative;
      .triangle {
        position: absolute;
        top: 55%;
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 10px solid #fc6c36;
        &.greenTriangle {
          border-top: none !important;
          border-bottom: 10px solid #29ba00 !important;
        }
      }
      .number {
        margin-left: 0.15rem;
        margin-right: 5px;
      }
      .unit {
        font-weight: 600;
      }
    }
  }
  .vehicleTrend {
    position: relative;
    width: 100%;
    height: 100%;
    .echarts_title {
      position: absolute;
      top: 5%;
      left: 0;
      font-size: 0.14rem;
      color: #333;
    }
    .echarts {
      width: 100%;
      height: 100%;
    }
  }
}
/**right**/
.page_right {
  .inStorage {
    .bookingInfo {
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 20%;
      width: 100%;
      > div {
        height: 100%;
        text-align: center;
        > p {
          margin-bottom: 15px;
        }
      }
    }
    .echart_complete {
      width: 100%;
      height: 30%;
      position: relative;
      .echartsComplete {
        width: 100%;
        height: 70%;
        position: absolute;
        top: 0%;
      }
      .echartsComplete2 {
        width: 100%;
        height: 70%;
        position: absolute;
        top: 0%;
      }
      .echartsLabel {
        position: absolute;
        top: 30%;
        left: 10%;
        color: #fff;
      }
      .splitLine {
        display: inline-block;
        position: absolute;
        width: 1px;
        height: 60%;
        top: 10%;
        left: 50%;
        background: #d1d1d1;
      }
      .echarts_title {
        position: absolute;
        bottom: 0;
        width: 100%;
        display: flex;
        justify-content: space-around;
      }
    }
    /**预约单状态**/
    .orderStatus {
      width: 100%;
      height: 50%;
      display: flex;
      > div {
        width: 25%;
        height: 100%;
        .echarts {
          width: 100%;
          height: 60%;
        }
        .number,
        .cGray {
          text-align: center;
          margin-bottom: 0.05rem;
        }
        .number {
          margin-right: 0;
        }
      }
    }
  }
  .bookingRate {
    position: relative;
    width: 100%;
    height: 100%;
    .echarts_title {
      line-height: 0.35rem;
      font-size: 0.14rem;
      color: #333;
    }
    .echartsArea {
      width: 100%;
      height: calc(100% - 0.35rem);
      display: flex;
      justify-content: center;
      .echarts {
        width: 50%;
        height: 100%;
      }
    }
  }
  /**近30天入库预约分析**/
  .inStorageBooking {
    position: relative;
    width: 100%;
    height: 100%;
    .echarts_title {
      position: absolute;
      top: 5%;
      left: 0;
      font-size: 0.14rem;
      color: #333;
    }
    .echarts {
      width: 100%;
      height: 100%;
    }
  }
}

/*****************中间部分***************/
.page_center {
  float: left;
  width: calc(50% - 20px);
  height: 100%;
  margin: 0 10px;
  &-top {
    box-sizing: border-box;
    width: 100%;
    height: 15%;
    display: flex;
    justify-content: space-between;
    .center_total {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 25%;
      padding: 0.1rem 0.15rem;
      margin-right: 2%;
      border-radius: 10px;
      color: #fff;
      font-size: 0.16rem;
      &.mr0 {
        margin-right: 0 !important;
      }
      p {
        margin: 0.15rem 0;
      }
      .number {
        font-size: 0.24rem;
        font-weight: 600;
        color: #fff;
      }
      .icon {
        position: relative;
        width: 0.3rem;
        height: 0.3rem;
        top: 20%;
        background: #ccc;
      }
    }
    .center_total:last-child {
      margin-right: 0%;
    }
    $colors: (0, #3e43f4, #006fec), (1, #2bb800, #05d200), (2, #0090da, #00ccce),
      (3, #fc6a36, #fc8536);
    @each $i, $colorStart, $colorEnd in $colors {
      .center_total_#{$i} {
        background: linear-gradient(90deg, $colorStart, $colorEnd);
        .total_icon_#{$i} {
          background: url("~@/assets/images/storageAnalysis/total_icon_#{$i}.png")
            no-repeat;
          background-size: 100% 100%;
        }
        .total_icon_0 {
          width: 0.29rem !important;
          height: 0.32rem !important;
        }
        .total_icon_1 {
          width: 0.28rem !important;
          height: 0.32rem !important;
        }
        .total_icon_2 {
          width: 0.32rem !important;
          height: 0.32rem !important;
        }
        .total_icon_3 {
          width: 0.28rem !important;
          height: 0.3rem !important;
        }
      }
    }
  }
  &-img {
    width: 100%;
    height: calc(85%);
    .title {
      height: 0.4rem;
      line-height: 0.4rem;
      color: #333;
      font-size: 0.14rem;
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      width: 100%;
      padding: 20px;
      width: 100%;
      height: calc(100% - 0.35rem);
      background-color: #fff;
      border-radius: 8px;
      img {
        text-align: center;
        width: 6.6rem;
        height: 4.9rem;
        max-width: 660px !important;
        max-height: 490px !important;
      }
    }
  }
}
</style>
